"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var MaterialBooleanControl_1 = __importStar(require("./MaterialBooleanControl"));
exports.MaterialBooleanControl = MaterialBooleanControl_1.default;
exports.materialBooleanControlTester = MaterialBooleanControl_1.materialBooleanControlTester;
var MaterialEnumControl_1 = __importStar(require("./MaterialEnumControl"));
exports.MaterialEnumControl = MaterialEnumControl_1.default;
exports.materialEnumControlTester = MaterialEnumControl_1.materialEnumControlTester;
var MaterialNativeControl_1 = __importStar(require("./MaterialNativeControl"));
exports.MaterialNativeControl = MaterialNativeControl_1.default;
exports.materialNativeControlTester = MaterialNativeControl_1.materialNativeControlTester;
var MaterialDateControl_1 = __importStar(require("./MaterialDateControl"));
exports.MaterialDateControl = MaterialDateControl_1.default;
exports.materialDateControlTester = MaterialDateControl_1.materialDateControlTester;
var MaterialDateTimeControl_1 = __importStar(require("./MaterialDateTimeControl"));
exports.MaterialDateTimeControl = MaterialDateTimeControl_1.default;
exports.materialDateTimeControlTester = MaterialDateTimeControl_1.materialDateTimeControlTester;
var MaterialSliderControl_1 = __importStar(require("./MaterialSliderControl"));
exports.MaterialSliderControl = MaterialSliderControl_1.default;
exports.materialSliderControlTester = MaterialSliderControl_1.materialSliderControlTester;
var MaterialRadioGroupControl_1 = __importStar(require("./MaterialRadioGroupControl"));
exports.MaterialRadioGroupControl = MaterialRadioGroupControl_1.default;
exports.materialRadioGroupControlTester = MaterialRadioGroupControl_1.materialRadioGroupControlTester;
var MaterialIntegerControl_1 = __importStar(require("./MaterialIntegerControl"));
exports.MaterialIntegerControl = MaterialIntegerControl_1.default;
exports.materialIntegerControlTester = MaterialIntegerControl_1.materialIntegerControlTester;
var MaterialNumberControl_1 = __importStar(require("./MaterialNumberControl"));
exports.MaterialNumberControl = MaterialNumberControl_1.default;
exports.materialNumberControlTester = MaterialNumberControl_1.materialNumberControlTester;
var MaterialTextControl_1 = __importStar(require("./MaterialTextControl"));
exports.MaterialTextControl = MaterialTextControl_1.default;
exports.materialTextControlTester = MaterialTextControl_1.materialTextControlTester;
var MaterialAnyOfStringOrEnumControl_1 = __importStar(require("./MaterialAnyOfStringOrEnumControl"));
exports.MaterialAnyOfStringOrEnumControl = MaterialAnyOfStringOrEnumControl_1.default;
exports.materialAnyOfStringOrEnumControlTester = MaterialAnyOfStringOrEnumControl_1.materialAnyOfStringOrEnumControlTester;
exports.Unwrapped = {
    MaterialBooleanControl: MaterialBooleanControl_1.MaterialBooleanControl,
    MaterialEnumControl: MaterialEnumControl_1.MaterialEnumControl,
    MaterialNativeControl: MaterialNativeControl_1.MaterialNativeControl,
    MaterialDateControl: MaterialDateControl_1.MaterialDateControl,
    MaterialDateTimeControl: MaterialDateTimeControl_1.MaterialDateTimeControl,
    MaterialSliderControl: MaterialSliderControl_1.MaterialSliderControl,
    MaterialRadioGroupControl: MaterialRadioGroupControl_1.MaterialRadioGroupControl,
    MaterialIntegerControl: MaterialIntegerControl_1.MaterialIntegerControl,
    MaterialNumberControl: MaterialNumberControl_1.MaterialNumberControl,
    MaterialTextControl: MaterialTextControl_1.MaterialTextControl,
    MaterialAnyOfStringOrEnumControl: MaterialAnyOfStringOrEnumControl_1.MaterialAnyOfStringOrEnumControl
};
//# sourceMappingURL=index.js.map